import { TOGGLE_SIDENAV } from '../actions/types';

export default function (state = false, action) {
  switch (action.type) {
    case TOGGLE_SIDENAV:
      return action.payload;
    default:
      return state;
  }
}
